import React, { Component } from "react";
import ModuleRatingsTable from "./Tables/ModuleRatingsTable";
import StudentRatingsTable from "./Tables/StudentRatingsTable";
import {
  fetchCourseGradesOnlyForLastSixMonths,
  fetchCourseGradesForAllTime,
} from "../../actions/coursesActions";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Card, CardBody, CardSubtitle, Button } from "reactstrap";
import { PacmanLoader } from "react-spinners";

class ModuleRatings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingForAllTime: false,
    };
  }
  componentDidMount() {
    this.props.dispatch(fetchCourseGradesOnlyForLastSixMonths());
  }

  handleGetAllTime = () => {
    this.setState({ showingForAllTime: true });
    this.props.dispatch(fetchCourseGradesForAllTime());
  };

  render() {
    let infoCardAboutOnlyShowingLastSixMonths = () => {
      return (
        <Card>
          <CardBody>
            <CardSubtitle>
              <FormattedMessage id="CurrentlyOnlyDataForTheLastSixMonthsIsShownPressToShowMore" />
            </CardSubtitle>
            <Button
              outline
              size="sm"
              color="primary"
              onClick={() => this.handleGetAllTime()}
            >
              <FormattedMessage id="ShowAllResults" />
            </Button>
          </CardBody>
        </Card>
      );
    };

    if (this.props.ratings.loading === true) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }
    if (this.props.table === "moduleGrade") {
      return (
        <>
          {!this.state.showingForAllTime ? (
            infoCardAboutOnlyShowingLastSixMonths()
          ) : (
            <></>
          )}
          <ModuleRatingsTable
            ratingsResponse={this.props.ratings.result}
            avgRating={this.props.avgRatings.result}
            totRatings={this.props.totRatings.result}
          />
        </>
      );
    } else if (this.props.table === "studGrade") {
      return (
        <>
          {!this.state.showingForAllTime ? (
            infoCardAboutOnlyShowingLastSixMonths()
          ) : (
            <></>
          )}
          <StudentRatingsTable comments={this.props.comments.result} />
        </>
      );
    }
  }
}

const mapStateToProps = (store) => {
  return {
    ratings: store.moduleRatingsReducer,
    avgRatings: store.avgRatingsReducer,
    totRatings: store.studentTotalRatingsReducer,
    comments: store.studentRatingsReducer,
  };
};

export default connect(mapStateToProps)(ModuleRatings);
